<template>
  <div class="pl-4">
    <div class="row mt-4 mr-0 ml-0 mb-4">
      <div class="col-lg-7 col-xs-6">
        <h2 class="f25">{{ institutional.name }}</h2>
      </div>

      <div class="col-lg-5 col-xs-6">
        <button
          @click="openForm(false, institutional)"
          class="right btn btn-primary-dark btn-lg"
          type="button"
        >
          <font-awesome-icon icon="plus" class="mr-3" />ADICIONAR VÍDEO
        </button>
      </div>
      <div class="col-lg-12 mt-2">
        <div class="container_gallery_mini">
          <div
            class="institucional_block_mini"
            v-for="video in institutional.gallery_items"
            :key="video.id"
          >
            <SlideItem
              v-if="video.video"
              :item="video"
              :open="
                () => {
                  openForm(video, institutional, true);
                }
              "
            />
            <video-embed
              @click="openForm(video, institutional, true)"
              v-if="video.iframe"
              :src="video.iframe"
            ></video-embed>

            <div class="p-2">
              <span
                @click="openForm(video, institutional, true)"
                class="f18 crop_tex pb-0 pointer d-block"
                >{{ video.name }}</span
              >
              <span
                style="color: #c0b3db; max-width: 500px"
                class="f12 text-truncate d-block"
                >{{ video.description }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mr-0 ml-0">
      <div class="col-lg-7 col-xs-12">
        <h2 class="f25">VÍDEOS GERAIS</h2>
      </div>
      <div class="col-lg-5 col-xs-12">
        <button
          @click="openForm(false, general, true)"
          class="right btn btn-primary-dark btn-lg"
          type="button"
        >
          <font-awesome-icon icon="plus" class="mr-3" />ADICIONAR VÍDEO
        </button>
      </div>
    </div>
    <div class="row mr-0 ml-0">
      <div class="col-lg-12 mt-2">
        <div class="container_gallery_mini">
          <div
            class="institucional_block_mini"
            v-for="video in general.gallery_items"
            :key="video.id"
          >
            <SlideItem
              v-if="video.video"
              :item="video"
              :open="
                () => {
                  openForm(video, institutional, true);
                }
              "
            />

            <video-embed
              @click="openForm(video, institutional, true)"
              v-if="video.iframe"
              :src="video.iframe"
            ></video-embed>

            <div class="p-2">
              <span
                @click="openForm(video, institutional, true)"
                class="f15 pb-0 pointer d-block"
                >{{ video.name }}</span
              >
              <span
                style="color: #c0b3db; max-width: 500px"
                class="f12 text-truncate d-block"
                >{{ video.description }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mr-0 ml-0">
      <div class="col-lg-12 col-xs-12 mt-4">
        <h2 class="f25">VÍDEOS DA VAGA</h2>
      </div>
    </div>
    <div class="row mr-0 ml-0" v-for="job in jobs" :key="job.id">
      <div class="col-lg-12 mt-2">
        <p v-if="job.gallery_items.length > 0" class="f20 color_light_gallery">
          {{ job.name }}
        </p>
        <div v-if="job.gallery_items.length > 0" class="container_gallery_mini">
          <div
            class="institucional_block_mini"
            v-for="video in job.gallery_items"
            :key="video.id"
          >
            <SlideItem
              class="institucional_load_mini"
              v-if="video.video"
              :item="video"
              :open="
                () => {
                  openForm(video, job, false);
                }
              "
            />

            <video-embed
              @click="openForm(video, institutional, true)"
              v-if="video.iframe"
              :src="video.iframe"
            ></video-embed>

            <div class="p-2">
              <span
                @click="openForm(video, job, false)"
                class="f15 pb-0 pointer"
                >{{ video.name }}</span
              >
              <br />
              <span style="color: #c0b3db; display: inline-flex" class="f12">{{
                video.description
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Form from "@/Recruiters/Galleries/Form.vue";
import SlideItem from "components/Slide/SlideItem.vue";
export default {
  components: { SlideItem },
  data: () => ({
    search: "",
    institutional: {
      gallery_items: [],
    },
    general: {},
    jobs: [],
  }),
  mounted() {
    this.getVideos();
    eventBus.$on("videoIndexGallery", (video) => {
      this.getVideos();
    });
  },
  methods: {
    getVideos() {
      axios.get("/recruiters/galleries/videos").then((response) => {
        this.institutional = response.data.institutional;
        this.jobs = response.data.jobs;
        this.general = response.data.general;
      });
    },
    openForm(video, gallery, delete_action = false) {
      this.$modal.show(
        Form,
        {
          video: video,
          gallery: gallery,
          delete_action: delete_action,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.getVideos();
          },
        }
      );
    },
  },
};
</script>
